module.exports = __webpack_public_path__ + "img/cross.ec0f6d0c.svg";